import { render } from "./RequestsTab.vue?vue&type=template&id=144fcba0&scoped=true"
import script from "./RequestsTab.vue?vue&type=script&lang=js"
export * from "./RequestsTab.vue?vue&type=script&lang=js"

import "./RequestsTab.vue?vue&type=style&index=0&id=144fcba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144fcba0"]])

export default __exports__